export default __webpack_public_path__ + "static/media/eropartner.d50b39fa.png";